import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton
} from '@material-ui/core';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';

const AdvancePaymentChequeDetailsDialog = ({ open, onClose, advancePaymentChequeDetails }) => {
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="advance-payment-details"
            fullWidth={fullWidth}
            maxWidth={maxWidth}
        >
            <DialogTitle id="advance-payment-details">
                Advance Payment Details
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    style={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Reference Number</TableCell>
                                <TableCell align="right">Amount (RS)</TableCell>
                                <TableCell align="right">Issuing Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {advancePaymentChequeDetails.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.referenceNumber ? item.referenceNumber : '-'}</TableCell>
                                    <TableCell align="right">
                                            {item.amount}
                                    </TableCell>
                                    <TableCell align="right">
                                            {moment(item.issuingDate).format('YYYY-MM-DD')}                                   </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default AdvancePaymentChequeDetailsDialog;
